<template>
    <input
        type="text"
        ref="input"
        :class="{'calendar-icon' : icon}"
        :required="required"
        :name="name"
        data-validator-trigger='datepicker.select'
    />
</template>

<script>
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            required: false,
            default: ''
        },
        icon: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            default: '' //future of history
        },
        minDate: {
            type: Date
        },
        maxDate: {
            type: Date
        }
    },
    data() {
        return {
            flatpickr: null
        }
    },
    watch: {
        value(value) {
            if ( value !== '' ) {
                this.flatpickr.setDate(value);
            }
            else {
                this.flatpickr.clear();
            }
        }
    },
    mounted() {

        let options = {
            locale: Dutch,
            altInput: true,
            altFormat: 'j F Y',
            dateFormat: 'Y-m-d',
            onChange: (selectedDates, dateStr, instance) => {
                
                if ( selectedDates.length ) {
                    this.$emit('input', this.$options.filters.datestring(selectedDates[0]));
                }
                else {
                    this.$emit('input', '');
                }

                let ev = new Event("datepicker.select", {"bubbles":true, "cancelable":false});
                this.$refs.input.dispatchEvent(ev);
            }
        };

        if ( this.type == 'future' ) {
            // options.minDate = "today";
            options.minDate = new Date();
            options.minDate.setDate(options.minDate.getDate() + 1);
            options.minDate.setHours(0,0,0,0);
        }
        else if ( this.type == 'history' ) {
            options.maxDate = new Date();
            options.minDate.setDate(options.maxDate.getDate() - 1);
            options.minDate.setHours(23,59,59,0);
        }

        if ( this.minDate ) {
            options.minDate = this.minDate;
        }

        if ( this.maxDate ) {
            options.maxDate = this.maxDate;
        }

        this.flatpickr = flatpickr(this.$refs.input, options);
    }
}
</script>
